<p-dialog
  modal="true"
  styleClass="atlas-dialog-l wl-transactions-grid-apply-payments-dialog"
  [closable]="false" [(visible)]="show"
>
  <ng-template pTemplate="header">
    <h3>{{ 'revenue.transactions-grid.apply-payments.new-payment' | translate | titlecase }}</h3>
  </ng-template>
  <wl-multi-invoice-payment [invoiceNumbers]="invoiceNumbers"></wl-multi-invoice-payment>
  <ng-template pTemplate="footer">
    <button pButton type="button" class="btn btn-secondary" (click)="this.show = false">
      {{ 'common.cancel' | translate | titlecase }}
    </button>
    <button pButton type="button" class="btn btn-primary" [disabled]="isSaving" (click)="applyClicked()">
      <span *ngIf="!isSaving">{{ 'common.apply' | translate | titlecase }}</span>
      <wl-busy *ngIf="isSaving" [show]="isSaving"></wl-busy>
    </button>
  </ng-template>
</p-dialog>
